import React, { useState } from "react";
import { Alert, Button, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ApiFetch from "../../utils/fetch";
import Loading from "../loading/loading";
import styles from "./SearchNroCliente.module.css";
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';

const apiFetch = new ApiFetch();

const SearchNroCliente = ({ hiddenLoginButton }) => {
  const [dniCuit, setDniCuit] = useState("");
  const [cliente, setCliente] = useState({ idCliente: "", nombre: "" });
  const [isOpen, setIsOpen] = useState(false);
  const [alert, setAlert] = useState("");
  const [loading, setLoading] = useState("");

  const search = async () => {
    try {
      setAlert("");
      setLoading(<Loading />);
      if (!dniCuit) {
        setLoading("");
        return;
      }
      const data = await apiFetch.GET_PUBLIC(`/public/nroAsociado/${dniCuit}`);
      setLoading("");
      if (data?.status === 200) {
        const nombre = data?.body?.nombre;
        const idCliente = data?.body?.idCliente;
        setCliente({ nombre, idCliente });
        setAlert(
          <Alert severity="success" icon={false}>
            <div className={styles.modalContent}>
              <span>
                <b>Asociado:</b> {nombre}
              </span>
              <span>
                <b>Número:</b> {idCliente}
                <Button
                  size="small"
                  onClick={() => handleCopy(idCliente)}
                  startIcon={<ContentCopyIcon />}
                  style={{ marginLeft: "8px" }}
                >
                  Copiar
                </Button>
              </span>
            </div>
          </Alert>
        );
        setIsOpen(true);
      } else {
        setIsOpen(false);
        setAlert(
          <Alert severity="error">
            {data?.message || "No fue posible obtener su Nro de Asociado."}
          </Alert>
        );
      }
    } catch (error) {
      setLoading("");
      setIsOpen(false);
      setAlert(
        <Alert severity="error">
          No fue posible obtener su Nro de Asociado.
        </Alert>
      );
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if ((value >= 0 || value <= 9) && value.length <= 12) {
      setDniCuit(value);
    }
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      search();
    }
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then((err) => {
      return;
    });
  };

  return (
    <div>
      <Alert severity="warning">
        ¿No conoces tu Nro de asociado? Consultalo ingresando tu DNI.
      </Alert>
      <br></br>
      <div className={styles.searchContainer}>
        <TextField
          onKeyDown={handleEnterKeyPress}
          onChange={(e) => handleChange(e)}
          label="DNI"
          size="small"
          value={dniCuit}
        />
        {alert}
        <Button
          onClick={() => search()}
          variant="outlined"
          size="small"
          endIcon={<SearchIcon />}
        >
          Consultar
        </Button>
      </div>
              {!hiddenLoginButton && (
          <a
            href="/tramites/servicios"
            style={{
              textDecoration: "none",
            }}
          >
            <Button color='success' variant="text" startIcon={<KeyboardArrowLeftRoundedIcon/> } size='small' className={styles.btnVolver} >Volver</Button>

          </a>
        )}
      {loading}
    </div>
  );
};

export { SearchNroCliente };
